module.exports = __webpack_public_path__ + "media/images/bg04-1a7e4bbdfe2f388093061dbdd70722db.png";